export enum AxisPositions {
    TOP = 'top',
    RIGHT = 'right',
    BOTTOM = 'bottom',
    LEFT = 'left',
    CENTER = 'center'
}

export enum ModalTypes {
    CONFIRMATION = 'confirmation',
    ALERT = 'alert',
    ERROR = 'error',
    NOTIFICATION = 'notification'
}

export enum ModalTexts {
    DELETE_POLL_MESSAGE = 'Are you sure you want to delete this poll?',
    DELETE_POLL_DONE_TEXT = 'Yes, delete the poll',
    RESET_POLL_MESSAGE = 'A reset deletes all votes. Are you sure you want to continue?',
    RESET_POLL_DONE_TEXT = 'Yes, reset the poll',
    LAUNCH_PREVIEW_MESSAGE = 'A preview of your presentation will open in a new browser window.',
    LAUNCH_PREVIEW_DONE_TEXT = 'Launch Preview',
    ADD_RESULTS_SLIDE_MESSAGE = 'Are you sure you want to add a Results Slide to your presentation?',
    ADD_RESULTS_SLIDE_DONE_TEXT = 'Yes, add a Results Slide',
}
